import { TextField } from '@mui/material';
import React from 'react';

export default function InputTheme({ ...props }) {
    return (
        <TextField sx={{bgcolor:'transparent'}} variant="standard" {...props} color="inputColor"  />
    )
}